import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import useHideEntities from '../../../../../hooks/useHideEntities';
import { FormCardContainer } from '../../../common/cards/NewFormCard';
import { DeclarationFormCardProps } from '../../../common/declaration.form.card';
import MultipleItemsCard from '../../../common/MultipleItemsCard';
import DeferredPaymentBlock from '../blocks/DeferredPaymentBlock';

const DeferredPaymentCard = ({
    viewOnly,
    getFieldHelpers,
    getFieldMeta,
    getFieldProps,
    toggleHelp,
    cardTotal,
    propsPathPrefix,
    keyCard,
}: DeclarationFormCardProps): ReactElement => {
    const { t } = useTranslation('form');
    const { isFormType } = useHideEntities();

    return (
        <MultipleItemsCard
            title={t('deferredPayment')}
            keyCard={keyCard}
            viewOnly={viewOnly}
            path={propsPathPrefix!}
            getFieldProps={getFieldProps}
            getFieldMeta={getFieldMeta}
            getFieldHelpers={getFieldHelpers}
            toggleHelp={toggleHelp}
            cardTotal={cardTotal}
            cardNumber={24}
            initialValues={{ id: '', categoryAndType: '' }}
            list={(list) => [
                { field: t('additionalDocumentID'), value: list.id },
                { field: t('deferredPaymentCategory/Type'), value: list.categoryAndType },
            ]}
            hidden={isFormType(['EXPORT_B1', 'IMPORT_H2'])}
            condensed
            refNumber="2/6"
        >
            {(path) => (
                <FormCardContainer>
                    <DeferredPaymentBlock path={path} />
                </FormCardContainer>
            )}
        </MultipleItemsCard>
    );
};

export default DeferredPaymentCard;
